"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStepLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _ProgressStepperStepLabelText = require("../ProgressStepperStepLabelText/ProgressStepperStepLabelText");
var _Text = require("../Text/Text");
var _ProgressStepperStepLabel = require("./ProgressStepperStepLabel.styles");
var _excluded = ["label", "meta"];
/**
 * Used by `ProgressStepperStep` to wrap a step's label text and any additional `meta` content.
 *
 * @since 8.57.0
 */
var ProgressStepperStepLabel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var _meta$type;
  var label = _ref.label,
    meta = _ref.meta,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var metaContent = meta;
  if (typeof meta === 'string') {
    metaContent = /*#__PURE__*/_react.default.createElement(_Text.Text, {
      fontType: "bodySmall"
    }, meta);
  } else if ((meta === null || meta === void 0 ? void 0 : (_meta$type = meta.type) === null || _meta$type === void 0 ? void 0 : _meta$type.displayName) === 'Tag') {
    // Force Tag to display at small size
    metaContent = /*#__PURE__*/(0, _react.cloneElement)(meta, {
      size: _constants.TAG_SIZES.sm
    });
  }
  return /*#__PURE__*/_react.default.createElement(_ProgressStepperStepLabel.StyledProgressStepperStepLabel, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_ProgressStepperStepLabelText.ProgressStepperStepLabelText, null, label), metaContent);
});
exports.ProgressStepperStepLabel = ProgressStepperStepLabel;
ProgressStepperStepLabel.displayName = 'ProgressStepperStepLabel';
ProgressStepperStepLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Label text of the step.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Additional content that will appear underneath the step label text. Currently,
   * `Tag` and text are officially supported. For more
   * customization options, you can use the `renderLabel` prop.
   *
   * It's best to avoid long `meta` values to help maintain understandability
   * for screen reader users.
   *
   * @since 8.57.0
   */
  meta: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
} : {};